import { Address, Entity, Label } from '../backend/types/entity.ts'

export function getDistinctLabels(labels: Label[]): Label[] {
    const labelsSet = new Set()
    const result = []

    for (const label of labels) {
        const key = `${label.Label.toLowerCase()}`

        if (!labelsSet.has(key)) {
            labelsSet.add(key)
            result.push(label)
        }
    }

    return result
}

export function getDistinctEntityLabels(entity: Entity): Label[] {
    return entity ? getDistinctLabels(entity.AddressesLabeled.map((addr) => addr.Labels || []).flat()) : []
}

export function getOriginLabelId(addresses: Address[]): string {
    const concatenatedAddresses = addresses
        .toSorted((a, b) => a.Address.localeCompare(b.Address))
        .map((a) => a.Address)
        .join('')
    return btoa(concatenatedAddresses)
}
